import { jsx as e } from "react/jsx-runtime";

import l from "../../../../utils/classNames/index.js";

const s = ({className: s, children: a, ...t}) => e("div", {
    ...t,
    className: l("gap-m flex h-full min-h-[340px] w-full flex-col items-center justify-center text-[#636466]", s),
    children: a || e("p", {
        className: "typography-h4 leading-6",
        children: "There is no data to be displayed"
    })
});

export { s as default };
//# sourceMappingURL=index.js.map
